import React, { forwardRef } from 'react';
import { Icon } from '../icon';
import { Menu, MenuListItem, useMenu } from '../menu';
import { IconButton } from '../icon-button';
import { Wrapper, TextWrapper, PrependWrapper, AppendWrapper } from './styled';
const options = ['Settings', 'Delete', 'New Section'];
/**
 *  @deprecated use ListItem instead
 *  */
export const MenuElement = forwardRef(function MenuElement({ children, prependElement, appendElement, onClick, isCollapsible, isOpen = false, subsection, selected, ...rest }, ref) {
    const { isOpenMenu, handleToggleMenu, handleCloseMenu } = useMenu(false);
    const PrependIcon = prependElement ? (React.createElement(Icon, { name: prependElement })) : (isCollapsible && React.createElement(Icon, { name: "keyboard_arrow_down" }));
    function handleAppendElement(e) {
        e.stopPropagation();
        handleToggleMenu();
    }
    const AppendIcon = appendElement ? (appendElement === 'kebab' ? (React.createElement(Menu, { isOpen: isOpenMenu, onClickOutside: handleCloseMenu, position: "bottom-start", content: React.createElement(React.Fragment, null, options.map((item, index) => (React.createElement(MenuListItem, { tabIndex: index, key: `${item}-${index}` }, item)))) },
        React.createElement(IconButton, { onClick: handleAppendElement },
            React.createElement(Icon, { name: "kebab" })))) : (React.createElement(IconButton, { onClick: handleAppendElement },
        React.createElement(Icon, { name: appendElement })))) : null;
    return (React.createElement(Wrapper, { onClick: onClick, ref: ref, ...rest },
        React.createElement(PrependWrapper, { isOpen: isOpen, isCollapsible: isCollapsible }, PrependIcon),
        React.createElement(TextWrapper, { subsection: subsection, selected: selected }, children),
        React.createElement(AppendWrapper, null, AppendIcon)));
});
